import React, { Component } from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import AttnLogo from '../components/attn-logo'
import VoteAmericaLogo from '../assets/img/svg/vote-america.svg'
import Footer from '../components/footer-new'

class VotePage extends Component {
  componentDidMount () {
    const script = document.createElement('script')
    script.setAttribute('src', 'https://cdn.voteamerica.com/embed/tools.js')
    script.async = true
    document.body.appendChild(script)
  }

  render () {
    return (
      <div className='vote'>
        <Helmet>
          <title>Vote - ATTN:</title>
          <script
            async
            src='https://www.googletagmanager.com/gtag/js?id=UA-53151320-1'
          />
          <script>{`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'UA-53151320-1');
          `}</script>
        </Helmet>
        <header className='candle-header'>
          <img src='/img/Candle_Logo_Alpha_07.png' />
        </header>
        <header className='vote-header'>
          <Link to='/'>
            <AttnLogo classes='logo' theme='dark' />
          </Link>
          <a
            className='client-logo'
            href='https://www.voteamerica.com/'
            target='_blank'
            rel='noreferrer noopener'
          >
            <img src={VoteAmericaLogo} alt='abc' />
          </a>
        </header>
        <div className='vote-form'>
          <div className='voteamerica-embed' data-subscriber='attn' data-tool='register' />
        </div>
        <Footer theme='dark' />
      </div>
    )
  }
}

export default VotePage



// WEBPACK FOOTER //
// ./src/pages/vote.js